import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    MENSAGEM_ENVIO: 'Enviar Mensagens'
}

export default [
    {
        name: ROUTER_NAMES.MENSAGEM_ENVIO,
        path: '/mensagens',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Mensagens',
            searchDescription: 'Envie mensagens para Fornecedores e Compradores',
            searchTerms: ['mensagens','mensagem'],
            hasRole: 'role/mensagens'
        },
        component: () => import('@/views/Mensagem')
    }
]